export const rupiah = (n) =>
  "Rp" + new Intl.NumberFormat("id-ID").format(Math.round(n || 0));

export const coinToRp = (c) => rupiah((c || 0) * 1000);

export const fmtCoin = (c) => new Intl.NumberFormat("id-ID").format(c || 0);

export const fmtDate = (iso) =>
  iso ? new Date(iso).toLocaleString("id-ID", { day: "numeric", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "-";

export const fmtTime = (iso) =>
  iso ? new Date(iso).toLocaleTimeString("id-ID", { hour: "2-digit", minute: "2-digit" }) : "";

export const addressText = (a) =>
  a ? [a.street, a.village, a.district, a.regency, a.province].filter(Boolean).join(", ") : "";

export const STATUS = {
  open: { label: "Menunggu Penawaran", cls: "bg-amber-100 text-amber-800" },
  requested: { label: "Menunggu Konfirmasi Worker", cls: "bg-amber-100 text-amber-800" },
  assigned: { label: "Worker Ditugaskan", cls: "bg-blue-100 text-blue-800" },
  on_the_way: { label: "Worker Menuju Lokasi", cls: "bg-blue-100 text-blue-800" },
  arrived: { label: "Worker Tiba", cls: "bg-indigo-100 text-indigo-800" },
  in_progress: { label: "Sedang Dikerjakan", cls: "bg-indigo-100 text-indigo-800" },
  submitted: { label: "Menunggu Konfirmasi Selesai", cls: "bg-teal-100 text-teal-800" },
  completed: { label: "Selesai", cls: "bg-emerald-100 text-emerald-800" },
  cancelled: { label: "Dibatalkan", cls: "bg-red-100 text-red-700" },
  rejected: { label: "Ditolak Worker", cls: "bg-red-100 text-red-700" },
};

export const ACTIVE = ["assigned", "on_the_way", "arrived", "in_progress", "submitted"];

export const TX_LABEL = {
  topup: "Top Up",
  escrow_hold: "Escrow Ditahan",
  escrow_release: "Pembayaran Diterima",
  fee: "Potongan Aplikasi",
  refund: "Pengembalian",
  payout: "Penarikan",
};

export const METHOD_LABEL = { bank_transfer: "Bank Transfer", ewallet: "E-Wallet", qris: "QRIS" };

export const DAYS = [
  ["mon", "Senin"], ["tue", "Selasa"], ["wed", "Rabu"], ["thu", "Kamis"],
  ["fri", "Jumat"], ["sat", "Sabtu"], ["sun", "Minggu"],
];

export function getGPS() {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) return reject(new Error("GPS tidak didukung"));
    navigator.geolocation.getCurrentPosition(
      (p) => resolve({ lat: p.coords.latitude, lng: p.coords.longitude }),
      () => reject(new Error("Izin lokasi ditolak")),
      { enableHighAccuracy: true, timeout: 10000 }
    );
  });
}

export async function reverseGeocode(lat, lng) {
  try {
    const r = await fetch(`https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${lat}&lon=${lng}&accept-language=id`);
    const j = await r.json();
    const a = j.address || {};
    return [a.suburb || a.village || a.neighbourhood, a.city || a.county || a.town, a.state].filter(Boolean).join(", ") || j.display_name;
  } catch (e) {
    return `${lat.toFixed(4)}, ${lng.toFixed(4)}`;
  }
}
